import Enum from "./Enum";

export default Enum.create( {
	ERROR: "ERROR",
	INDETERMINATE: "INDETERMINATE",
	INFO: "INFO",
	PENDING: "PENDING",
	SUCCESS: "SUCCESS",
	WARN: "WARN",
	SYSTEM: "SYSTEM",
	BOT: "SYSTEM", // alias
} );
